module.exports = __webpack_public_path__ + "img/down-black.1bd70ee4.jpg";